<template>
  <div>
    <v-dialog v-model="visible" max-width="600px">
      <v-card>
        <v-toolbar color="#f9f9f9">
          <v-toolbar-title>投保须知及声明</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-list class="notice-list">
          <v-list-tile>
            <v-list-tile-title>
              <a class="notice-list-link" @click="agreement">《投保须知》</a>
            </v-list-tile-title>
          </v-list-tile>
          <v-divider class="ml-4"></v-divider>
          <v-list-tile> 
            <v-list-tile-title>
              <a
                class="notice-list-link"
                target="_blank"
                href="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/baoxianjingjifuwuweituoshouquanshu.pdf"
              >《保险经纪委托协议》</a>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>
    <Agreement v-model="agreementVisible"></Agreement>
  </div>
</template>

<script>
import Agreement from "@/components/Product/ZFAgreement";
export default {
  components: {
    Agreement
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      agreementVisible: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  methods: {
    agreement() {
      this.visible = false;
      this.agreementVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-list {
  .notice-list-link {
    color: inherit;
    text-decoration: none;
  }
}
</style>